// extracted by mini-css-extract-plugin
module.exports = {"className":"textBodyM_className__v9jW9"};